export const createNewCompanyValue = 'createNew';

export const MAX_MATCHING_ALERTS_COUNT = 5;
